import React from 'react'
import { COLORS, SEAT_STATUSES, SEAT_TYPES } from '../constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWheelchair } from '@fortawesome/free-solid-svg-icons'

const ColorLabels = ({ showStatusesLabel, isTableMap, isSVGMap, svgData }) => {
  return (
    <div
      className='colorLabelsContainer'
      style={{ color: isSVGMap ? 'white' : 'black' }}
    >
      <div
        className='colorLabelLine'
        style={{ backgroundColor: svgData.bgColor || 'transparent' }}
      >
        {showStatusesLabel[SEAT_STATUSES.HOLD] && (
          <div
            className='colorLabel'
            style={{ background: svgData.bgColor || 'white' }}
          >
            <div
              style={{ backgroundColor: `${COLORS.HOLD}` }}
              className='colorLabelColor'
            />
            <span className='colorLabelText'>On Hold</span>
          </div>
        )}
        {showStatusesLabel[SEAT_STATUSES.BLOCKED] && (
          <div
            className='colorLabel'
            style={{ background: svgData.bgColor || 'white' }}
          >
            <div
              style={{ backgroundColor: `${COLORS.BLOCKED}` }}
              className='colorLabelColor'
            />
            <span className='colorLabelText'>Blocked</span>
          </div>
        )}
        <div
          className='colorLabel'
          style={{ background: svgData.bgColor || 'white' }}
        >
          <div
            style={{
              backgroundColor: isSVGMap ? 'white' : `${COLORS.AVAILABLE}`
            }}
            className='colorLabelColor'
          />
          <span className='colorLabelText'>Available</span>
        </div>
        {showStatusesLabel[SEAT_STATUSES.PREDEFINED] && (
          <div
            className='colorLabel'
            style={{ background: svgData.bgColor || 'white' }}
          >
            <div
              style={{ backgroundColor: `${COLORS.PREDEFINED}` }}
              className='colorLabelColor'
            />
            <span className='colorLabelText'>Predefined</span>
          </div>
        )}
        {showStatusesLabel[SEAT_STATUSES.RESERVED] && (
          <div
            className='colorLabel'
            style={{ background: svgData.bgColor || 'white' }}
          >
            <div
              style={{ backgroundColor: `${COLORS.RESERVED}` }}
              className='colorLabelColor'
            />
            <span className='colorLabelText'>
              {isTableMap ? 'Locked for Purchase' : 'Reserved'}
            </span>
          </div>
        )}
        <div
          className='colorLabel'
          style={{ background: svgData.bgColor || 'white' }}
        >
          <div
            style={{ backgroundColor: `${COLORS.BOOKED}` }}
            className='colorLabelColor'
          />
          <span className='colorLabelText'>Sold</span>
        </div>
      </div>
      {showStatusesLabel[SEAT_TYPES.WHEELCHAIR] && (
        <div
          className='colorLabelLine'
          style={{
            justifyContent: 'left',
            backgroundColor: '#dae5f1',
            width: '100%'
          }}
        >
          <div
            className='colorLabel'
            style={{
              backgroundColor: svgData.bgColor || 'transparent',
              marginLeft: '8px'
            }}
          >
            <div
              style={{ backgroundColor: `transparent` }}
              className='colorLabelColor'
            >
              <FontAwesomeIcon
                className='colorLabelColorWheelchairIcon'
                icon={faWheelchair}
              />
            </div>
            <span className='colorLabelText'>
              Accessible seating is available
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export { ColorLabels }
